import { render, staticRenderFns } from "./StoreLocatorConfigReviews.vue?vue&type=template&id=c7e85a6a&scoped=true&"
import script from "./StoreLocatorConfigReviews.vue?vue&type=script&lang=js&"
export * from "./StoreLocatorConfigReviews.vue?vue&type=script&lang=js&"
import style0 from "./StoreLocatorConfigReviews.vue?vue&type=style&index=0&id=c7e85a6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7e85a6a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
